import {BaseService} from "./base.service";

class NotesService extends BaseService {

    constructor() {
        super('api/notes-for-supplier');
    }

}

export const notesService = new NotesService();
